const rodzajNapedu = { t: 'Rodzaj napędu', name: 'naped', hint: { url: '/construction_drive' }}
export default rodzajNapedu